export { default } from './requirePropFactory';